











































import { Vue, Component } from "vue-property-decorator";
import { Template } from "@/models/template";

@Component
export default class BaseDataForm extends Vue {
  // Vuex store with lightweight typed wrapper
  readonly store = this.$store.direct;

  form: { name?: string; description?: string; source?: File } = {
    name: undefined,
    description: undefined,
    source: undefined
  };

  get valid() {
    return (
      this.form.name &&
      this.form.name.length > 0 &&
      this.form.name.length < 30 &&
      this.form.description &&
      this.form.description.length > 0 &&
      this.form.description.length < 200 &&
      this.form.source &&
      this.form.source.size < 1e7
    );
  }
}
